<template>
  <v-row>
    <v-col>
      <v-autocomplete
        :items="items"
        item-value="text"
        item-text="text"
        outlined
        label="Operatörsberoende"
        v-model="model"
        :disabled="readonly"
      >
      </v-autocomplete>
    </v-col>
  </v-row>
</template>

<script>
import { sync } from 'vuex-pathify'

export default {
  name: 'OdocOperatorBeroendeInput',

  props: {
    readonly: Boolean
  },

  data() {
    return {
      items: [
        {
          text: 'Nej',
          value: false
        },
        {
          text: 'Ja',
          value: true
        }
      ]
    }
  },

  computed: {
    model: sync('odoc/model@operator_beroende')
  }
}
</script>
